import { Flex, FlexProps, Stack, Text } from '@chakra-ui/react';

import { columnWidths } from './columns-width';

export function HeadingListPromo() {
  const headerFlexProps: FlexProps = {
    w: 'full',
    justifyContent: 'space-between',
    bgColor: '#E6E6F6',
    px: 4,
    py: 5,
    fontWeight: 'bold',
    overflowX: 'auto',
    gap: 2,
    textAlign: 'center',
    alignItems: 'center',
  };
  return (
    <Flex {...headerFlexProps}>
      <Stack w={columnWidths.dragHandle} />
      <Flex
        maxW="1117px"
        w="full"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack w={columnWidths.promoBanner}>
          <Text>Banner Promo</Text>
        </Stack>
        <Stack w={columnWidths.brand}>
          <Text>Brand</Text>
        </Stack>
        <Stack w={columnWidths.mechanism}>
          <Text>Mekanisme</Text>
        </Stack>
        <Stack w={columnWidths.period}>
          <Text>Periode</Text>
        </Stack>
        <Stack w={columnWidths.code}>
          <Text>Kode</Text>
        </Stack>
        <Stack w={columnWidths.type}>
          <Text>Jenis</Text>
        </Stack>
        <Stack w={columnWidths.productHighlight}>
          <Text>Product Highlight</Text>
        </Stack>
        <Stack w={columnWidths.status}>
          <Text>Status</Text>
        </Stack>
        <Stack w={columnWidths.displayInSOL}>
          <Text>Tampil di SOL</Text>
        </Stack>
        <Stack w={columnWidths.homeBanner}>
          <Text>Banner Beranda</Text>
        </Stack>
      </Flex>
    </Flex>
  );
}
